module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers-table",
    attrs: {
      "id": "pers-tab2-7",
      "name": "hres32e-tab2-tab7"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.detail2Tab7Table,
      "data": _vm.detail,
      "maxRowspan": _vm.maxRowspanDetail6,
      "addInlineEventBool": true,
      "editInlineEventBool": true,
      "deleteInlineEventBool": true,
      "deleteInlineBtnDisp": false,
      "saveInlineBtnDisp": _vm.validateStaappr,
      "saveInlineEvent": _vm.callSave,
      "flgToggle": _vm.personalDataActive
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray pull-left",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.togglePage(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6d64872d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres32e/tab2_7.vue
// module id = 3846
// module chunks = 1